import { styled } from '@uhg-abyss/web/tools/styled';
import { Flex } from '@uhg-abyss/web/ui/Flex';

import { Markdown } from '../Markdown';

export const BannerStyled = styled(Flex, {
  backgroundColor: '$core.color.brand.5',
  justifyContent: 'center',
  alignItems: 'center',
  flexWrap: 'wrap',
  borderTop: '1px solid $core.color.brand.60',
  borderBottom: '1px solid $core.color.brand.60',
  padding: '16px ',
  '@media (max-width: 744px)': {
    display: 'inline-block',
    '& div': {
      display: 'inline',
    },
  },
  '@media (max-width: 464px)': {
    padding: '8px 16px',
  },
});

export const IconContainer = styled('div', {
  height: '18px',
  width: '18px',
  '@media (max-width: 464px)': {
    position: 'relative',
    top: '4px',
  },
});

export const StyledMarkdown = styled(Markdown, {
  marginLeft: '4px',
  fontSize: '$md',
  lineHeight: '20px',
  color: '$core.color.neutral.90',
  flex: 1,
  '& span': {
    marginLeft: '14px',
  },
  '@media (max-width: 464px)': {
    fontSize: '$sm',
    lineHeight: '18px',

    '& span': {
      display: 'block',
      marginLeft: 0,
    },
  },
});
